import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { KeyCodeUtils } from '../../../base/common/keyCodes.js';
import { BaseResolvedKeybinding } from './baseResolvedKeybinding.js';
/**
 * Do not instantiate. Use KeybindingService to get a ResolvedKeybinding seeded with information about the current kb layout.
 */

export var USLayoutResolvedKeybinding = /*#__PURE__*/function (_BaseResolvedKeybindi) {
  _inherits(USLayoutResolvedKeybinding, _BaseResolvedKeybindi);

  var _super = _createSuper(USLayoutResolvedKeybinding);

  function USLayoutResolvedKeybinding(actual, os) {
    _classCallCheck(this, USLayoutResolvedKeybinding);

    return _super.call(this, os, actual.parts);
  }

  _createClass(USLayoutResolvedKeybinding, [{
    key: "_keyCodeToUILabel",
    value: function _keyCodeToUILabel(keyCode) {
      if (this._os === 2
      /* Macintosh */
      ) {
        switch (keyCode) {
          case 15
          /* LeftArrow */
          :
            return '←';

          case 16
          /* UpArrow */
          :
            return '↑';

          case 17
          /* RightArrow */
          :
            return '→';

          case 18
          /* DownArrow */
          :
            return '↓';
        }
      }

      return KeyCodeUtils.toString(keyCode);
    }
  }, {
    key: "_getLabel",
    value: function _getLabel(keybinding) {
      if (keybinding.isDuplicateModifierCase()) {
        return '';
      }

      return this._keyCodeToUILabel(keybinding.keyCode);
    }
  }, {
    key: "_getAriaLabel",
    value: function _getAriaLabel(keybinding) {
      if (keybinding.isDuplicateModifierCase()) {
        return '';
      }

      return KeyCodeUtils.toString(keybinding.keyCode);
    }
  }, {
    key: "_getDispatchPart",
    value: function _getDispatchPart(keybinding) {
      return USLayoutResolvedKeybinding.getDispatchStr(keybinding);
    }
  }], [{
    key: "getDispatchStr",
    value: function getDispatchStr(keybinding) {
      if (keybinding.isModifierKey()) {
        return null;
      }

      var result = '';

      if (keybinding.ctrlKey) {
        result += 'ctrl+';
      }

      if (keybinding.shiftKey) {
        result += 'shift+';
      }

      if (keybinding.altKey) {
        result += 'alt+';
      }

      if (keybinding.metaKey) {
        result += 'meta+';
      }

      result += KeyCodeUtils.toString(keybinding.keyCode);
      return result;
    }
  }]);

  return USLayoutResolvedKeybinding;
}(BaseResolvedKeybinding);